// extracted by mini-css-extract-plugin
export default {"FooterText":"FooterFooter_FooterText__IDp7w","FooterHeaderText":"FooterFooter_FooterHeaderText__KyHYm"};